import { ChartNumberType } from '../../interfaces';
import { setChartSettingChartNumberTypeAction } from '../../../../redux/slices/analyses';
import { useAppDispatch } from '../../../../redux/hooks';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../../Icon';
import { isSkipPercentView } from '../../utils';
import { borderedContent } from '../../../../styles/shareableStyles';
import ThinDivider from '../../../ThinDivider';
import KubitTooltip from '../../../KubitTooltip';
import { useChartContext } from '../../ChartContext';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 28px;
  padding-top: 1px;
  padding-bottom: 1px;
  ${borderedContent};
`;

export default () => {
  const {
    metadata: { query, analysisId },
    settings: { chartSettings },
    chartData,
  } = useChartContext();
  const dispatch = useAppDispatch();
  const { chartNumberType } = chartSettings;
  const setChartNumberTypeHandler = (newType: ChartNumberType) => {
    dispatch(setChartSettingChartNumberTypeAction({ analysisId, newType }));
  };
  const disablePercentView =
    chartData.queryType === QueryType.Expression
      ? isSkipPercentView(query, chartData.measureControls)
      : false;

  return (
    <Container>
      <KubitTooltip
        content={'Number view'}
        placement="bottom-start"
        noOpenDelay={true}
      >
        <IconWrapper
          onClick={() => setChartNumberTypeHandler(ChartNumberType.Number)}
        >
          <SvgIcon
            name={'hashtag'}
            isActive={chartNumberType === ChartNumberType.Number}
            width={16}
            height={16}
          />
        </IconWrapper>
      </KubitTooltip>
      <ThinDivider layout="vertical" size="full" />
      <KubitTooltip
        content={
          disablePercentView
            ? 'Percent view is not supported when formula has division or non-countable measure function.'
            : 'Percent view'
        }
        placement="bottom-start"
        noOpenDelay={true}
      >
        <IconWrapper
          isDisabled={disablePercentView}
          onClick={() => {
            if (!disablePercentView) {
              setChartNumberTypeHandler(ChartNumberType.Percentage);
            }
          }}
        >
          <SvgIcon
            name={'percent'}
            isActive={chartNumberType === ChartNumberType.Percentage}
            width={16}
            height={16}
          />
        </IconWrapper>
      </KubitTooltip>
    </Container>
  );
};
